export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_amzPurchaseNo') || '采购单号',
    field: 'amzPurchaseNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzPurchaseStatus') || '单据状态',
    field: 'amzPurchaseStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_purchaseDate') || '下单日期',
    field: 'purchaseDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesPerson') || '业务开发',
    field: 'salesPersonName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_buyer') || '负责采购',
    field: 'buyerName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '执行工厂',
    field: 'scmName',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_settlementFactory') || '结算工厂',
    field: 'settlementFactoryName',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderSource') || '订单合同名称（甲方）',
    field: 'v_orderSource',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_importanceLevel') || '订单性质',
    field: 'v_importanceLevel',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzFirstDemandNo') || '新品首单需求单号',
    field: 'amzFirstDemandNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'amzFirstDemandNo' },
  },
  {
    title: that.$l('table_label_skuSalesChannel') || '产品类型',
    field: 'skuSalesChannel',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'skuSalesChannel' },
  },
  {
    title: that.$l('table_label_totalQty') || '采购数量',
    field: 'totalQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalAmount') || '采购金额',
    field: 'totalAmount',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { totalAmount, v_currencyUnit } = row
      return [that.format(totalAmount) || '0', v_currencyUnit].join(' ')
    },
  },
  {
    title: that.$l('table_label_quotedMethod') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDate') || '最早交期',
    field: 'deliveryDate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_factoryPaymentTerms') || '付款条件',
    field: 'v_factoryPaymentTerms',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderScm') || '名义工厂',
    field: 'orderScmName',
    minWidth: 220,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_importanceLevelDesc') || '重要级别说明',
    field: 'importanceLevelDesc',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注说明',
    field: 'remark',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_createBy') || '创建人',
    field: 'createBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('table_label_modifyBy') || '修改人',
    field: 'modifyBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
  {
    title: that.$l('table_label_submitBy') || '提交人',
    field: 'submitBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'submitInfo' },
  },
  {
    title: that.$l('table_label_reviewBy') || '审核人',
    field: 'reviewBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reviewInfo' },
  },
]
